/* eslint-disable max-len */
import React, { useState } from 'react';
import { useAppSelector } from '../../../../Redux/Store/hooks';
import { CatalogFileRoot } from '../../../../common/libraries/fileFormats/catalog/catalog';
import { softwareReleaseBuildId } from '../../../../globals/version';

type FooterComponentParameters = {
  sourceData : CatalogFileRoot,
  changeLanguage : (language: string) => void,
  changeTheme : () => void
};

export function FooterComponent({ sourceData, changeLanguage, changeTheme }: FooterComponentParameters) {
  const [year] = useState(new Date().getFullYear());

  const language = useAppSelector((state) => {
    return state.TextsReducer.language;
  })!;

  const catalogKeyAndVersion = `(${sourceData.sourceData.catalogKey.substring(0, 8)}-${sourceData.sourceData.catalogRevision})`;

  return (
    <footer className="footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-3">
            <label className="form-check-label row" htmlFor="dark-mode-switch">
              <input className="col-3 form-check-input" type="checkbox" role="switch" id="dark-mode-switch" onChange={() => { changeTheme(); }} />
              <div className="col-9" style={{ color: 'white', fontSize: '14px' }}>Dark Mode</div>
            </label>

          </div>
          <div className="col-6 footer-info align-items-center" style={{ padding: '0px' }}>
            <div className="align-items-center">
              &copy;
              {year}
              {' '}
              Mind S.A.
              {' - '}
              {softwareReleaseBuildId}
              {' - '}
              {catalogKeyAndVersion}
            </div>
          </div>
          <div className="col-3 row align-items-center">
            <button
              type="button"
              className="col-2 languageButton"
              style={{
                textDecoration: language === 'PT' ? 'underline' : 'none',
              }}
              onClick={() => {
                changeLanguage('PT');
              }}
            >
              PT
            </button>
            <button
              type="button"
              className="col-2 languageButton"
              style={{
                textDecoration: language === 'EN' ? 'underline' : 'none',
              }}
              onClick={() => {
                changeLanguage('EN');
              }}
            >
              EN
            </button>
            <button
              type="button"
              className="col-2 languageButton"
              style={{
                textDecoration: language === 'DE' ? 'underline' : 'none',
              }}
              onClick={() => {
                changeLanguage('DE');
              }}
            >
              DE
            </button>
            <button
              type="button"
              className="col-2 languageButton"
              style={{
                textDecoration: language === 'FR' ? 'underline' : 'none',
              }}
              onClick={() => {
                changeLanguage('FR');
              }}
            >
              FR
            </button>

            <button
              type="button"
              className="col-2 languageButton"
              style={{
                textDecoration: language === 'ES' ? 'underline' : 'none',
              }}
              onClick={() => {
                changeLanguage('ES');
              }}
            >
              ES
            </button>

          </div>
        </div>
      </div>
    </footer>
  );
}
